import React, {useEffect, useState} from "react";
import styled from "styled-components";
import {useAtom} from "jotai";
import {modalController} from "../../store";
import {ModalBody, ModalFooter, ModalHeader} from "../modal/Modal";
import {CancelButton} from "../../assets/GlobalStyles";
import {PreviewSubmit} from "../table/styles";

export default function SwitchComponent(props) {
  const {value, cellProps, type, eventClick} = props
  const [select, setSelect] = useState(value)
  const [, setModal] = useAtom(modalController)
  useEffect(() => {
    return () => {
      setModal({
        isShow: false
      })
    }
  }, [])

  useEffect(() => {
    if (type === 'publish') {
      setSelect(cellProps.data.publishYn === 'Y')
    } else {
      setSelect(cellProps.data.interlockYn === 'Y')
    }
  }, [value]);

  const handleClick = async (confirm) => {
    if (confirm) {
      const result = await eventClick();
      if (result === false) {
        setModal({isShow: false});
        return;
      }
      setSelect(!select)
      if (type === 'publish') {
        cellProps.data.publishYn = cellProps.data.publishYn === 'Y' ? 'N' : 'Y';
      } else {
        cellProps.data.interlockYn = cellProps.data.interlockYn === 'Y' ? 'N'
            : 'Y';
      }
    } else {
      setSelect(select)
    }
    setModal({isShow: false});
  }
  const showModal = () => {
    const btnSmall = {width: 100, height: 42}
    setModal({
      isShow: true,
      width: 400,
      modalComponent: () => {
        return (
            <div>
              {type !== 'publish' && <ModalHeader title={'연동 상태 변경'}
                                                  closeButton/>}
              <ModalBody>
                <p style={{fontSize: 16, paddingTop: 10}}>
                  {type !== 'publish' ? (!select ? '연동을 사용 하시겠습니까?'
                      : '연동을 중지 하시겠습니까?') : '게재 상태를 변경하시겠습니까?'}
                </p>
              </ModalBody>
              <ModalFooter style={{borderTop: 0, paddingTop: 5}}>
                <CancelButton style={btnSmall} onClick={() => handleClick(
                    false)}>취소</CancelButton>
                <PreviewSubmit style={btnSmall} onClick={() => handleClick(
                    true)}>확인</PreviewSubmit>
              </ModalFooter>
            </div>
        )
      }
    })
  }

  return (
      <SwitchBox
          type="button"
          role="switch"
          aria-checked={select}
          aria-label={type === "publish" ? `게재 ${select ? "중지" : "시작"}` : `연동 ${select ? "중지" : "시작"}`}
          $active={select}
          onClick={() => showModal()}
      >
        <SwitchKnob $active={select}/>
        <SwitchText $active={select}>{select ? "ON" : "OFF"}</SwitchText>
      </SwitchBox>
  )
}

const SwitchBox = styled.button`
  position: relative;
  display: inline-flex;
  width: 50px;
  height: 24px;
  align-items: center;
  justify-content: ${({$active}) => $active ? "flex-start" : "flex-end"};
  padding: 0 7px;
  border: 1px solid ${({$active}) => $active ? "#e87618" : "#d7dadd"};
  border-radius: 999px;
  background: ${({$active}) => $active ? "#f5811f" : "#f1f3f5"};
  color: ${({$active}) => $active ? "#fff" : "#7d858c"};
  cursor: pointer;
  transition: background 150ms ease, border-color 150ms ease;

  &:hover { box-shadow: 0 0 0 3px rgba(245, 129, 31, 0.12); }
  &:focus-visible { outline: 2px solid rgba(245, 129, 31, 0.35); outline-offset: 2px; }
`;

const SwitchKnob = styled.span`
  position: absolute;
  top: 3px;
  left: ${({$active}) => $active ? "29px" : "3px"};
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(31, 38, 44, 0.24);
  transition: left 150ms ease;
`;

const SwitchText = styled.span`
  position: relative;
  z-index: 1;
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.02em;
`;
